import React from 'react';
import { func, number, string } from 'prop-types';

import Button from '../../../../../../button/Button';

import './StepControls.scss';

const StepControls = ({ labelNext, onNext, stepNumber, stepTotal }) => {
  return (
    <div className="step-controls">
      <div className="step-counter">
        Pages {stepNumber}/{stepTotal}
      </div>
      <Button
        className="next-button -primary"
        // TODO: Use type instead of color modifying classes when changing
        // button appearance (type="primary")
        onClick={onNext}
      >
        {labelNext}
      </Button>
    </div>
  );
};

StepControls.propTypes = {
  labelNext: string.isRequired,
  onNext: func,
  stepNumber: number.isRequired,
  stepTotal: number.isRequired
};

StepControls.defaultProps = {
  onNext: undefined
};

export default StepControls;
